import React from 'react';
import { useParams } from 'react-router-dom';
import { LandingView } from '../components/public/LandingView';

/** Landing pública de cualquier empresa: /landing/:slug */
export function PublicLanding() {
  const {
    slug = ''
  } = useParams();
  return <LandingView slug={slug} data-id="element-1744" data-mp="jygabxxtauo5" />;
}